/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SessionBalanceUpdateDTO = {
  accountId?: string;
  isCashTransaction?: boolean;
  operationTypeEnum?: SessionBalanceUpdateDTO.operationTypeEnum;
  paymentMethodEnum?: SessionBalanceUpdateDTO.paymentMethodEnum;
  sessionId?: string;
  transactionAmount?: number;
  transactionType?: SessionBalanceUpdateDTO.transactionType;
  userId?: string;
  walletId?: string;
};

export namespace SessionBalanceUpdateDTO {
  export enum operationTypeEnum {
    CASH = "CASH",
    POS = "POS",
    USSD = "USSD",
    QR_CODE = "QR_CODE",
    IN_BANK_TRANSFER = "IN_BANK_TRANSFER",
    MOMO = "MOMO",
    PAYMENT_LINK = "PAYMENT_LINK",
    OUT_BANK_TRANSFER = "OUT_BANK_TRANSFER",
    REFUND = "REFUND",
    CARD = "CARD",
  }

  export enum paymentMethodEnum {
    USSD = "USSD",
    QR_CODE = "QR_CODE",
    IN_BANK_TRANSFER = "IN_BANK_TRANSFER",
    MOMO = "MOMO",
    OUT_BANK_TRANSFER = "OUT_BANK_TRANSFER",
    REFUND = "REFUND",
    PAYMENT_LINK_CARD = "PAYMENT_LINK_CARD",
    PAYMENT_LINK_USSD = "PAYMENT_LINK_USSD",
    PAYMENT_LINK_QR_CODE = "PAYMENT_LINK_QR_CODE",
    PAYMENT_LINK_BANK_TRANSFER = "PAYMENT_LINK_BANK_TRANSFER",
    STAMP_DUTY = "STAMP_DUTY",
    POS = "POS",
    TRANSACTION_CHARGE = "TRANSACTION_CHARGE",
  }

  export enum transactionType {
    IN = "IN",
    OUT = "OUT",
  }
}
